// Helper function to convert FileList or File[] to File[]
export function ensureFileArray(files: FileList | File[] | null | undefined): File[] {
    if (!files) {
        return [];
    }
    if (files instanceof FileList) {
        return Array.from(files);
    }
    return files; // Already an array
}
